<template>
  <j-modal
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk()"
    cancelText="关闭"
    switchFullscreen
  >
    <!-- <dev-bpbj-warehousing-list-form
      :disabled="disableSubmit"
      :tableData="selectData"
      @ok="submitCallback"
      ref="realForm"
    ></dev-bpbj-warehousing-list-form>-->
    <DevBpbjInfoList pageType="select" ref="infoList" />
  </j-modal>
</template>

<script>
  import DevBpbjInfoList from '../DevBpbjInfoList.vue'

  import DevBpbjWarehousingListForm from './DevBpbjWarehousingListForm'
  export default {
    name: 'DevBpbjWarehousingListModal',
    components: {
      DevBpbjWarehousingListForm, DevBpbjInfoList
    },
    data () {
      return {
        title: '选择备品备件',
        width: 1300,
        visible: false,
        disableSubmit: false,
        selectData: []
      }
    },
    methods: {
      add () {
        this.visible = true
        // this.$nextTick(() => {
        //   this.$refs.realForm.add()
        // })
      },
      edit (record) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.edit(record)
        })
      },
      close () {
        this.$emit('close')
        this.visible = false
      },
      handleOk (v) {
        const { selectionRows } = this.$refs.infoList
        this.$emit('ok', selectionRows)
        this.visible = false
      },
      submitCallback (v) {
        this.$emit('ok', v)

        //  this.selectData = v
        this.visible = false
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>
